import { makeStyles, Zoom } from '@material-ui/core';
import { useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const CircularCountdown = ({ label, onComplete = () => {}, size, matchFontSize, ...restProps }) => {
  const classes = useStyles();
  const [zoomIn, setZoomIn] = useState(true);

  return (
    <div className={classes.root}>
      <div style={{ marginRight: '1em' }}>{label}</div>
      <Zoom in={zoomIn} timeout={250}>
        <div>
          <CountdownCircleTimer
            isPlaying={true}
            size={size || 50}
            strokeWidth={6}
            trailColor={'rgba(0,0,0,0)'}
            colors={[['#000000']]}
            duration={5}
            onComplete={() => {
              setZoomIn(false);
              onComplete();
            }}
            {...restProps}>
            {({ remainingTime }) => <div style={{ fontSize: matchFontSize ? size / 2.5 : 'unset' }}>{remainingTime}</div>}
          </CountdownCircleTimer>
        </div>
      </Zoom>
    </div>
  );
};

export default CircularCountdown;
